import {
  CREATE_USER_IF_NOT_EXIST
} from './constants';
import {makeCall} from '../../../utils/request';
import {buildOptions, getEndPoints} from '../../../utils/api-call';

/** @type {OAuth2Store.State} */
export const state = {};

/** @type {OAuth2Store.Actions} */
export const actions = {
  [CREATE_USER_IF_NOT_EXIST] ({ commit }, { body, options }) {
    if (!body.idToken) {
      throw new Error('body.idToken cannot be empty.');
    }
    return makeCall(
      getEndPoints().oauth2.createUserIfNotExist,
      buildOptions('POST', body, null, options),
      commit
    );
  }
};

/** @type {OAuth2Store.Getters} */
export const getters = {};

/** @type {OAuth2Store.Mutations} */
export const mutations = {};

/** @type {VuexModule<OAuth2Store.State>} */
export default {
  state,
  actions,
  getters,
  mutations
};
